import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import SelectionNav from '../components/SelectionNav';
import {onSelectionNavDrag} from '../actions/ImageActions';
import {withRouter} from 'react-router-dom';
import size from 'lodash/size';
import indexOf from 'lodash/indexOf';
import {nextIndex, prevIndex} from '../utils';

@withRouter
@connect(state => ({
    nav: state.selectedImages.nav,
    myImagesSettings: state.myImagesSettings,
    images: state.images,
}), {
    onSelectionNavDrag,
})
export default class SelectionNavContainer extends Component {
    static propTypes = {
        nav: PropTypes.object,
        selectedImages: PropTypes.array.isRequired,
        onSelectionNavDrag: PropTypes.func,
        history: PropTypes.object,
        currentId: PropTypes.number,
        isDemo: PropTypes.bool,
        preventKeyNavigation: PropTypes.bool,
    };

    render() {
        const {selectedImages, nav, history, currentId, isDemo, preventKeyNavigation} = this.props;
        const sz = size(selectedImages);
        if (sz === 0) {
            return false;
        }

        const currentIdx = indexOf(selectedImages, currentId);

        const idx = sz > currentIdx && currentIdx >= 0 ? currentIdx : 0;
        const pIdx = prevIndex(idx, sz);
        const prevId = sz > 0 ? selectedImages[pIdx] : null;
        const nIdx = nextIndex(idx, sz);
        const nextId = sz > 0 ? selectedImages[nIdx] : null;

        return (
            <SelectionNav
                urlPrefix={isDemo ? '/demo' : ''}
                images={selectedImages}
                position={nav}
                onSelectionNavDrag={this.props.onSelectionNavDrag}
                history={history}
                currentId={currentId}
                currentIdx={currentIdx}
                prevId={prevId}
                nextId={nextId}
                preventKeyNavigation={preventKeyNavigation}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/SelectionNavContainer.js